<template>
    <div class="merchant-app-section">
        <div class="row">
            <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-9">
            <p class="merchant-app-section-title">Ownership Information #{{ownerNumber}}</p>
            </div>
            <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-3 text-right">
                <b-button style="background-color:red;" @click="$emit('removeForm')">Remove</b-button>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <textInputBase
                label="Owner Name"
                nameclass="merchant-app-field"
                v-model="ownerForms.owner_name"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <textInputBase
                label="Street Address"
                nameclass="merchant-app-field"
                v-model="ownerForms.street_address"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <stateInputBase
                label="State"
                nameclass="merchant-app-field"
                v-model="ownerForms.state"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <emailInputBase
                label="Email"
                nameclass="merchant-app-field"
                v-model="ownerForms.email"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <numberInputBase
                label="SSN"
                nameclass="merchant-app-field"
                v-model="ownerForms.ssn"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="merchant-app-field">
                <label>Rent or Own?</label>
                <b-form-select
                v-model="ownerForms.business_status"
                :options="status"
                size="lg"
                :style="{
                    backgroundColor: ownerForms.business_status
                    ? 'rgba(79, 208, 110,0.2)'
                    : 'aliceblue',
                }"
                >
                <template v-slot:first>
                    <b-form-select-option value="null" disabled>-- Please select an option --</b-form-select-option>
                </template>
                </b-form-select>
            </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <phoneInputBase
                label="Phone"
                nameclass="merchant-app-field"
                v-model="ownerForms.phone_number"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <stateInputBase
                label="Drivers License or ID State"
                nameclass="merchant-app-field last-field-left"
                v-model="ownerForms.license_state"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <textInputBase
                placeholder="CEO, Partner, etc."
                label="Title"
                nameclass="merchant-app-field"
                v-model="ownerForms.title"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <textInputBase
                placeholder="City"
                label="City"
                nameclass="merchant-app-field"
                v-model="ownerForms.city"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <textInputBase
                placeholder="Zip"
                label="Zip / Postal Code"
                nameclass="merchant-app-field"
                v-model="ownerForms.postal_code"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <dateInputBase
                placeholder="MM/DD/YY"
                label="Date of Birth"
                nameclass="merchant-app-field"
                v-model="ownerForms.date_of_birth"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="merchant-app-field">
                <label>Equity Ownership</label>
                <b-form-select
                v-model="ownerForms.ownership"
                :options="equity"
                size="lg"
                :style="{
                    backgroundColor: ownerForms.ownership
                    ? 'rgba(79, 208, 110,0.2)'
                    : 'aliceblue',
                }"
                >
                <template v-slot:first>
                    <b-form-select-option value="null" disabled>-- Please select an option --</b-form-select-option>
                </template>
                </b-form-select>
            </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                    placeholder="Years"
                    label="How long at location"
                    nameclass="merchant-app-field dual-input-1"
                    v-model="ownerForms.long_at_location_year"
                />
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <numberInputBase
                    placeholder="Months"
                    label
                    nameclass="merchant-app-field dual-input-2"
                    v-model="ownerForms.long_at_location_month"
                />
                </div>
            </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <numberInputBase
                      placeholder="Years"
                      label="Length of ownership"
                      nameclass="merchant-app-field dual-input-1"
                      v-model="ownerForms.length_of_ownership_year"
                    />
                  </div>
                  <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <numberInputBase
                      placeholder="Months"
                      label
                      nameclass="merchant-app-field dual-input-2"
                      v-model="ownerForms.length_of_ownership_month"
                    />
                  </div>
                </div>
              </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <textInputBase
                label="Drivers License or ID#"
                nameclass="merchant-app-field last-field-left"
                v-model="ownerForms.driver_license_id"
            />
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <dateInputBase
                placeholder="MM/DD/YY"
                label="Drivers License or ID expiry Date"
                nameclass="merchant-app-field last-field-right"
                v-model="ownerForms.license_expiry"
            />
            </div>
        </div>
    </div>
</template>

<script>
import helper from '@/helper/helper';
import {
  textInputBase,
  transInputBase,
  emailInputBase,
  phoneInputBase,
  numberInputBase,
  moneyInputBase,
  percentInputBase,
  stateInputBase,
  zoneInputBase,
  operateInputBase,
  typeBusinessInputBase,
  dateInputBase,
  choicesInputBase,
  crediCardInputBase,
  cartInputBase,
  documentationBase
} from "../forms/baseForms";

export default {
    mixins: [helper],
    props: ["ownerForms", "ownerNumber"],
    components: {
        textInputBase,
        emailInputBase,
        phoneInputBase,
        numberInputBase,
        moneyInputBase,
        percentInputBase,
        stateInputBase,
        zoneInputBase,
        operateInputBase,
        typeBusinessInputBase,
        dateInputBase,
        choicesInputBase,
        transInputBase,
        crediCardInputBase,
        cartInputBase,
        documentationBase,
    },
    mounted() {
        this.fillEquity();
    },
    data()  {
        return {
            equity: [],
            status: [
                { value: "Rent", text: "Rent" },
                { value: "Own", text: "Own" }
            ],
        }
    },
    methods: {
        fillEquity() {
            for (var i = 1; i <= 100; i++) {
                this.equity.push({ value: i, text: i + "%" });
            }
        },
    }
}
</script>

<style scoped>

</style>